<script setup lang="ts">
 /**
 * Page-width constraint wrapper. Centers content on desktop
 * with max-w-lg and inherits parent gap for consistent spacing.
 * Use inside AppPagePanel for pages that shouldn't stretch full-width.
 */
</script>

<template>
  <div class="flex w-full flex-col gap-[inherit] sm:mx-auto sm:max-w-lg">
    <slot />
  </div>
</template>
